import algoliasearch from 'algoliasearch/lite';
import { Configure, Index, InstantSearch, RefinementList } from 'react-instantsearch-hooks-web';
import { Autocomplete, OrdersHit, QuotesHit, InfiniteHits, Stats } from './components';
import { ABB_ORDERS_INDEX_NAME, ABB_QUOTES_INDEX_NAME, database, errors } from './constants';
import { Panel } from './widgets/Panel';
import React, { useState } from "react";
import './App.css';

function App() {
  let userData;
  const logo = require('./images/logo.svg');
  const [errorMessages, setErrorMessages] = useState<any>({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [algoliaApiKey, setAlgoliaApiKey] = useState('');
  
  const searchClient = algoliasearch(
    'VEBZO2T4WP',
    algoliaApiKey
  );

  const handleSubmit = async (event) => {
    //Prevent page reload
    event.preventDefault();

    var { email, pass } = document.forms[0];

    // Find user login info
    userData = database.find((user) => user.email === email.value);
    // Compare user info
    if (userData) {
      if (userData.password !== pass.value) {
        // Invalid password
        setErrorMessages({ name: "pass", message: errors.pass });
      } else {
        await sendData(); //send user data for filtering based on accounts
        setIsSubmitted(true);
        localStorage.setItem('token-info', JSON.stringify(userData));
      }
    } else {
      // Email not found
      setErrorMessages({ name: "email", message: errors.email });
    }
  };

  const sendData = () => {
    fetch('/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData)
    })
      .then((res) => res.json())
      .then((result) => {
        setAlgoliaApiKey(result.ALGOLIA_API_KEY)
      })
      .catch((err) => console.log('error'))
  }

  const logout = () => {
    localStorage.removeItem('token-info');
    setIsSubmitted(false);
  };

  // Generate JSX code for error message
  const renderErrorMessage = (name) =>
    name === errorMessages.name && (
      <div className="error">{errorMessages.message}</div>
    );
  
  // JSX code for login form
  const renderForm = (
    <div className="app">
      <div className="login-form">
        <div className="title">Sign In</div>
          <div className="form">
            <form onSubmit={handleSubmit}>
              <div className="input-container">
                <label>Email </label>
                <input type="text" name="email" required />
                {renderErrorMessage("email")}
              </div>
              <div className="input-container">
                <label>Password </label>
                <input type="password" name="pass" required />
                {renderErrorMessage("pass")}
              </div>
              <div className="button-container">
                <input type="submit" />
              </div>
            </form>
          </div>
      </div>
    </div>
  );

  const loginSuccessPage = (
    <div>
      <InstantSearch
        searchClient={searchClient}
        indexName={ABB_ORDERS_INDEX_NAME}
        routing
      >
        <header className="header">
          <div className="header-wrapper wrapper">
            <nav className="header-nav">
              <a href="/"><img className="img-logo" src={logo} alt="ABB"/></a>
            </nav>
            <Autocomplete
              searchClient={searchClient}
              placeholder="Search"
              detachedMediaQuery="none"
              openOnFocus
            />
            <div className="logout-container">
              <button onClickCapture={logout}>logout</button>
          </div>
          </div>
        </header>
        <div className="container wrapper">
          <div>
             <Panel header="Order Customer">
              <RefinementList
                attribute="ReportingCustName"
                showMore={true}
                searchable={true}
              />
            </Panel>
            <Panel header="Country">
              {/* <HierarchicalMenu
                attributes={INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES}
              /> */}
              <RefinementList
                attribute="ReportingCustCountry"
                showMore={true}
              />
            </Panel>
          </div>
          <div className="results">
            <Configure 
              hitsPerPage={8} 
              attributesToSnippet={['ReportingCustName:4', 'MaterialDesc:15']} 
              snippetEllipsisText="…"/>
            <div className="ordersTab">
              <h3>Orders</h3>
              <Stats/>
              <InfiniteHits hitComponent={OrdersHit} />
            </div>
            <Index indexId="quotes_index" indexName={ABB_QUOTES_INDEX_NAME}>
              <Configure 
                hitsPerPage={8} 
                attributesToSnippet={['CustomerName:4', 'quoteName:4']} 
                snippetEllipsisText="…"/>
              <div className="quotesTab">
                <h3>Quotes</h3>
                <Stats/>
                <InfiniteHits hitComponent={QuotesHit} />
              </div> 
            </Index>
          </div>
        </div>
      </InstantSearch>
    </div>
  );

  return (
    <div>{isSubmitted && algoliaApiKey ? loginSuccessPage : renderForm}</div>
  );
}

export default App;